// extracted by mini-css-extract-plugin
module.exports = {"EditContents":"EditContents_EditContents__buuYy"};